import { v4 as uuidv4 } from 'uuid'

export const poTransmissionMethods = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Transmission Method ' + ++index,
  __typename: 'POTransmissionMethod'
}))
